import { createContext, useContext, useState } from "react";

const LowBalanceAlertContext = createContext();

export const LowBalanceAlertProvider = ({ children }) => {

    const [showAlert, setShowAlert] = useState(false);

    return (
        <LowBalanceAlertContext.Provider
            value={{
                showAlert,
                setShowAlert,
            }}
        >
            {children}
        </LowBalanceAlertContext.Provider>
    );
};

export const useLowBalanceAlert = () =>
    useContext(LowBalanceAlertContext);